import de from './de';
import en from './en';
import es from './es';
import fr from './fr';
import nl from './nl';

export const GeneralTranslations = {
  de,
  en,
  es,
  fr,
  nl,
};
